/** Signature options for Switzerland Admission / Invoice letters (`title` in API body). */
export const listSwitzerlandAdmissionSignatures: Record<string, string> = {
  "Admission Letter": "Admission Letter",
  "Conditional Admission Letter": "Conditional Admission Letter",
};

export type SwitzerlandStudentLetterTemplateName =
  | "OLD"
  | "NEW"
  | "NEW_WITH_SIGH"
  | "ASIA"
  | "SUGUMARAN"
  | "SUGUMARAN_SIGNATURE"
  | "INESA_MIKHNO";

/**
 * UI signature label → uni2 `/student-letter` `template_name`.
 * Juliet Derchi uses NEW until backend confirms another template key.
 */
export const listSwitzerlandStudentLetterSignatures: Record<string, SwitzerlandStudentLetterTemplateName> = {
  "Juliet Derchi": "NEW",
  "Inesa Mikhno": "INESA_MIKHNO",
  "The Director Santhosh Sugumaran": "SUGUMARAN",
  "The Director Santhosh Sugumaran + signature": "SUGUMARAN_SIGNATURE",
};

export const SWITZERLAND_STUDENT_LETTER_SIGNATURE_LABELS = Object.keys(listSwitzerlandStudentLetterSignatures);
export const SWITZERLAND_ADMISSION_SIGNATURE_LABELS = Object.keys(listSwitzerlandAdmissionSignatures);
